(function() { module.exports = window["eventespresso"]["events"]; }());